export default __webpack_public_path__ + "static/media/handle.7a09d62d.jpg";